import { FontEntry } from '../../types/font'

export const austinNewsDeck: FontEntry = {
  displayName: 'austin-news-deck',
  weights: {
    400: {
      normal: { file: 'AustinNewsDeck-Regular', extension: 'woff2', format: 'woff2' },
      italic: null
    },
    500: {
      normal: null,
      italic: { file: 'AustinNewsDeck-MediumItalic', extension: 'woff2', format: 'woff2' }
    },
    600: {
      normal: { file: 'AustinNewsDeck-SemiBold', extension: 'woff2', format: 'woff2' },
      italic: null
    }
  }
}
